import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Container, Table, Button, Badge, Row, Col, Input, Modal, ModalHeader, ModalBody, Pagination, PaginationItem, PaginationLink, Card, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Alert } from 'reactstrap';
import BreadCrumb from "../../../../../Components/Common/BreadCrumb";
import EmailLogContext from "../../../../../Components/Contexts/Management/EmailLogContext";
// WAS (until #584): only the old modal used it.
// import EmailTemplateContext from "../../../../../Components/Contexts/Management/EmailTemplateContext";
import { listSystemTemplates } from "../../../../../services/emailAyarService";
import SablonGonder from "./SablonGonder";
// WAS (until #584): only the old modal used it.
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// WAS (until #584): only the old modal used it.
// import Select from 'react-select';
import { ToastContainer } from 'react-toastify';   // WAS (until #584): { ToastContainer, toast }, toast was only used by the old modal
import 'react-toastify/dist/ReactToastify.css';
// WAS (until #584): only the old modal used it.
// import CreatableSelect from 'react-select/creatable';

// WAS (until #584): the CKEditor plugins of the old modal.
// import {
//     ClassicEditor,
//     AccessibilityHelp,
//     Alignment,
//     Autoformat,
//     AutoImage,
//     AutoLink,
//     Autosave,
//     Base64UploadAdapter,
//     BlockQuote,
//     Bold,
//     Code,
//     CodeBlock,
//     Essentials,
//     FindAndReplace,
//     FontBackgroundColor,
//     FontColor,
//     FontFamily,
//     FontSize,
//     FullPage,
//     GeneralHtmlSupport,
//     Heading,
//     Highlight,
//     HorizontalLine,
//     HtmlComment,
//     HtmlEmbed,
//     ImageBlock,
//     ImageCaption,
//     ImageInline,
//     ImageInsert,
//     ImageInsertViaUrl,
//     ImageResize,
//     ImageStyle,
//     ImageTextAlternative,
//     ImageToolbar,
//     ImageUpload,
//     Indent,
//     IndentBlock,
//     Italic,
//     Link,
//     LinkImage,
//     List,
//     ListProperties,
//     Markdown,
//     MediaEmbed,
//     Mention,
//     PageBreak,
//     Paragraph,
//     PasteFromMarkdownExperimental,
//     PasteFromOffice,
//     RemoveFormat,
//     SelectAll,
//     ShowBlocks,
//     SourceEditing,
//     SpecialCharacters,
//     SpecialCharactersArrows,
//     SpecialCharactersCurrency,
//     SpecialCharactersEssentials,
//     SpecialCharactersLatin,
//     SpecialCharactersMathematical,
//     SpecialCharactersText,
//     Strikethrough,
//     Style,
//     Subscript,
//     Superscript,
//     TextPartLanguage,
//     TextTransformation,
//     Title,
//     TodoList,
//     Underline,
//     Undo
// } from 'ckeditor5';
import { useTranslation } from "react-i18next";
import i18n, { currentLocaleTag } from "../../../../../i18n";

const Logs = () => {
  const { t } = useTranslation("moduller");
    useEffect(() => { document.title = i18n.t("moduller:emailsLogs.mailKayitlariFds"); }, []);

    const { emailLogs, fetchEmailLogs, getEmailLogById, loading } = useContext(EmailLogContext);   // WAS (until #584): also searchUsers, sendEmail, systemEmails, getSystemEmails (the old modal)
// WAS (until #584): the old modal's template calls.
//     const { getEmailTemplates, saveOrUpdateTemplate } = useContext(EmailTemplateContext);
// WAS (until #584): the old modal's template list.
//     const [emailTemplates, setEmailTemplates] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
// WAS (until #584): the old modal's chosen template.
//     const [selectedTemplate, setSelectedTemplate] = useState();
    const [search, setSearch] = useState("");
    // #573: hangi sistem postası (anahtar) ve yalnız gitmeyenler
    const [templateKey, setTemplateKey] = useState("");
    const [failedOnly, setFailedOnly] = useState(false);
    const [sablonAnahtarlari, setSablonAnahtarlari] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedLog, setSelectedLog] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
// WAS (until #584): the old modal's state.
//     const [sendModalOpen, setSendModalOpen] = useState(false);
//     const [selectedUsers, setSelectedUsers] = useState([]);
//     const userId = localStorage.getItem('userId');
//     const [userOptions, setUserOptions] = useState([]);
//     const [newEmail, setNewEmail] = useState({
//         templateId: "",
//         recipients: "",
//         ccRecipients: [], // Boş dizi olarak ayarlandı
//         sender: "",
//         subject: "",
//         content: "",
//         templateName: ""
//     });
    // #584: the "Şablonu gönder" form (SablonGonder.jsx); the mails go through the queue, so the list is read again now and a few seconds later
    const [gonderAcik, setGonderAcik] = useState(false);
    const gonderildi = () => {
        fetchEmailLogs(page, limit, search, templateKey, failedOnly);
        setTimeout(() => fetchEmailLogs(page, limit, search, templateKey, failedOnly), 3000);
    };


// WAS (until #584): the CKEditor settings of the old modal (the new form writes no text: the template is sent as stored).
//     const editorConfig = {
//         toolbar: {
//             items: [
//                 'undo',
//                 'redo',
//                 '|',
//                 'sourceEditing',
//                 'showBlocks',
//                 'findAndReplace',
//                 'textPartLanguage',
//                 '|',
//                 'heading',
//                 'style',
//                 '|',
//                 'fontSize',
//                 'fontFamily',
//                 'fontColor',
//                 'fontBackgroundColor',
//                 '|',
//                 'bold',
//                 'italic',
//                 'underline',
//                 'strikethrough',
//                 'subscript',
//                 'superscript',
//                 'code',
//                 'removeFormat',
//                 '|',
//                 'specialCharacters',
//                 'horizontalLine',
//                 'pageBreak',
//                 'link',
//                 'insertImage',
//                 'mediaEmbed',
//                 'highlight',
//                 'blockQuote',
//                 'codeBlock',
//                 'htmlEmbed',
//                 '|',
//                 'alignment',
//                 '|',
//                 'bulletedList',
//                 'numberedList',
//                 'todoList',
//                 'outdent',
//                 'indent'
//             ],
//             shouldNotGroupWhenFull: true
//         },
//         plugins: [
//             AccessibilityHelp,
//             Alignment,
//             Autoformat,
//             AutoImage,
//             AutoLink,
//             Autosave,
//             Base64UploadAdapter,
//             BlockQuote,
//             Bold,
//             Code,
//             CodeBlock,
//             Essentials,
//             FindAndReplace,
//             FontBackgroundColor,
//             FontColor,
//             FontFamily,
//             FontSize,
//             FullPage,
//             GeneralHtmlSupport,
//             Heading,
//             Highlight,
//             HorizontalLine,
//             HtmlComment,
//             HtmlEmbed,
//             ImageBlock,
//             ImageCaption,
//             ImageInline,
//             ImageInsert,
//             ImageInsertViaUrl,
//             ImageResize,
//             ImageStyle,
//             ImageTextAlternative,
//             ImageToolbar,
//             ImageUpload,
//             Indent,
//             IndentBlock,
//             Italic,
//             Link,
//             LinkImage,
//             List,
//             ListProperties,
//             Markdown,
//             MediaEmbed,
//             Mention,
//             PageBreak,
//             Paragraph,
//             PasteFromMarkdownExperimental,
//             PasteFromOffice,
//             RemoveFormat,
//             SelectAll,
//             ShowBlocks,
//             SourceEditing,
//             SpecialCharacters,
//             SpecialCharactersArrows,
//             SpecialCharactersCurrency,
//             SpecialCharactersEssentials,
//             SpecialCharactersLatin,
//             SpecialCharactersMathematical,
//             SpecialCharactersText,
//             Strikethrough,
//             Style,
//             Subscript,
//             Superscript,
//             TextPartLanguage,
//             TextTransformation,
//             Title,
//             TodoList,
//             Underline,
//             Undo
//         ],
//         fontFamily: {
//             supportAllValues: true
//         },
//         fontSize: {
//             options: ['default', 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72],
//             supportAllValues: true
//         },
//         heading: {
//             options: [
//                 {
//                     model: 'paragraph',
//                     title: 'Paragraph',
//                     class: 'ck-heading_paragraph'
//                 },
//                 {
//                     model: 'heading1',
//                     view: 'h1',
//                     title: 'Heading 1',
//                     class: 'ck-heading_heading1'
//                 },
//                 {
//                     model: 'heading2',
//                     view: 'h2',
//                     title: 'Heading 2',
//                     class: 'ck-heading_heading2'
//                 },
//                 {
//                     model: 'heading3',
//                     view: 'h3',
//                     title: 'Heading 3',
//                     class: 'ck-heading_heading3'
//                 },
//                 {
//                     model: 'heading4',
//                     view: 'h4',
//                     title: 'Heading 4',
//                     class: 'ck-heading_heading4'
//                 },
//                 {
//                     model: 'heading5',
//                     view: 'h5',
//                     title: 'Heading 5',
//                     class: 'ck-heading_heading5'
//                 },
//                 {
//                     model: 'heading6',
//                     view: 'h6',
//                     title: 'Heading 6',
//                     class: 'ck-heading_heading6'
//                 }
//             ]
//         },
//         htmlSupport: {
//             allow: [
//                 {
//                     name: /^.*$/,
//                     styles: true,
//                     attributes: true,
//                     classes: true
//                 }
//             ]
//         },
//         image: {
//             toolbar: [
//                 'toggleImageCaption',
//                 'imageTextAlternative',
//                 '|',
//                 'imageStyle:inline',
//                 'imageStyle:wrapText',
//                 'imageStyle:breakText',
//                 '|',
//                 'resizeImage'
//             ]
//         },
//         language: 'tr',
//         link: {
//             addTargetToExternalLinks: true,
//             defaultProtocol: 'https://',
//             decorators: {
//                 toggleDownloadable: {
//                     mode: 'manual',
//                     label: 'Downloadable',
//                     attributes: {
//                         download: 'file'
//                     }
//                 }
//             }
//         },
//         list: {
//             properties: {
//                 styles: true,
//                 startIndex: true,
//                 reversed: true
//             }
//         },
//         mention: {
//             feeds: [
//                 {
//                     marker: '@',
//                     feed: [
//                     ]
//                 }
//             ]
//         },
//         placeholder: 'Type or paste your content here!',
//         style: {
//             definitions: [
//                 {
//                     name: 'Article category',
//                     element: 'h3',
//                     classes: ['category']
//                 },
//                 {
//                     name: 'Title',
//                     element: 'h2',
//                     classes: ['document-title']
//                 },
//                 {
//                     name: 'Subtitle',
//                     element: 'h3',
//                     classes: ['document-subtitle']
//                 },
//                 {
//                     name: 'Info box',
//                     element: 'p',
//                     classes: ['info-box']
//                 },
//                 {
//                     name: 'Side quote',
//                     element: 'blockquote',
//                     classes: ['side-quote']
//                 },
//                 {
//                     name: 'Marker',
//                     element: 'span',
//                     classes: ['marker']
//                 },
//                 {
//                     name: 'Spoiler',
//                     element: 'span',
//                     classes: ['spoiler']
//                 },
//                 {
//                     name: 'Code (dark)',
//                     element: 'pre',
//                     classes: ['fancy-code', 'fancy-code-dark']
//                 },
//                 {
//                     name: 'Code (bright)',
//                     element: 'pre',
//                     classes: ['fancy-code', 'fancy-code-bright']
//                 }
//             ]
//         },
//     };

// WAS (until #584): opened and closed the old modal.
//     const toggleSendModal = () => {
//         setSendModalOpen(!sendModalOpen);
//
//         if (!sendModalOpen) {
//             fetchTemplates();
//             setNewEmail({ ...newEmail, templateId: "", content: "" });
//         }
//     };
//
//     useEffect(() => {
//         async function run() {
//             if (sendModalOpen && newEmail.templateId) {
//                 setNewEmail({ ...newEmail, templateId: newEmail.templateId });
//             }
//         }
//         run();
//     }, [sendModalOpen]);

// WAS (until #584): loaded the old modal's templates.
//     const fetchTemplates = async () => {
//         try {
//             const data = await getEmailTemplates(1, 200);
//             if (data && data.data) {
//                 console.log("Fetched Email Templates:", data.data);
//                 setEmailTemplates(data.data);
//             } else {
//                 console.log("No data found for templates");
//             }
//         } catch (error) {
//             console.error("Error fetching templates:", error);
//         }
//     };

// WAS (until #584): loaded the old modal's "Kimden" list (the new form asks GET /email/send/options).
//     useEffect(() => {
//         getSystemEmails();
//     }, [getSystemEmails]);

// WAS (until #584): the old modal's template picker.
//     const handleTemplateChange = (e) => {
//         const selectedTemplateId = parseInt(e.target.value, 10);
//         const selectedTemplate = emailTemplates.find(
//             (template) => template.email_template_id === selectedTemplateId
//         );
//     
//         setNewEmail((prevState) => ({
//             ...prevState,
//             templateId: selectedTemplateId,
//             konu: selectedTemplate ? selectedTemplate.email_template_title : "",
//             content: selectedTemplate ? selectedTemplate.email_template_content : ""
//         }));
//     
//         setSelectedTemplate(selectedTemplateId); // Seçilen şablonun ID'sini kaydet
//     
//         // Log ekleyelim
//         console.log("Şablon Seçildi:", {
//             selectedTemplateId,
//             title: selectedTemplate ? selectedTemplate.email_template_title : "",
//             content: selectedTemplate ? selectedTemplate.email_template_content : ""
//         });
//     };
    

// WAS (until #584): filled the old modal's subject from the chosen template.
//     // Şablon değiştiğinde konu otomatik olarak güncellenir
//     useEffect(() => {
//         async function run() {
//             if (newEmail.templateId) {
//                 const selectedTemplate = emailTemplates.find(
//                     (template) => template.email_template_id === newEmail.templateId
//                 );
//                 setNewEmail((prevState) => ({
//                     ...prevState,
//                     konu: selectedTemplate ? selectedTemplate.email_template_title : ""
//                 }));
//             }
//         }
//         run();
//     }, [newEmail.templateId, emailTemplates]); // Hem templateId hem de emailTemplates değişikliklerini izler


    // WAS (until #573):
    // useEffect(() => {
    //     fetchEmailLogs(page, limit, search);
    // }, [page, limit, search]);
    useEffect(() => {
        fetchEmailLogs(page, limit, search, templateKey, failedOnly);
    }, [page, limit, search, templateKey, failedOnly]);

    // Süzgeçteki anahtarlar kayıt defterinden gelir (yeni bir sistem postası eklenince burada kendiliğinden görünür); TEST ve "-" (şablonsuz) sabit.
    useEffect(() => {
        let ignore = false;
        async function run() {
            try {
                const d = await listSystemTemplates();
                if (!ignore) setSablonAnahtarlari(d.map((x) => x.template_key));
            } catch (e) {
                console.error('Error fetching system template keys:', e);
            }
        }
        run();
        return () => { ignore = true; };
    }, []);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleDetail = async (id) => {
        const log = await getEmailLogById(id);
        setSelectedLog(log);
        setModalOpen(true);
    };

// WAS (until #584): sent through the dead Node endpoint.
//     const handleSendEmail = async () => {
//         if (!newEmail.konu || !newEmail.content || (selectedUsers.length === 0 && newEmail.ccRecipients.length === 0)) {
//             return;
//         }
//
//         try {
//             const userId = localStorage.getItem('userId');
//             const senderId = systemEmails.find(email => email.system_email_value === newEmail.sender)?.system_email_id;
//             
//             await sendEmail({
//                 senderId, // Eğer userId yoksa bu değeri kullanacak
//                 userId,   // userId mevcutsa bu değeri kullanacak
//                 recipients: selectedUsers.map(user => user.value),
//                 ccRecipients: newEmail.ccRecipients,
//                 subject: newEmail.konu,
//                 content: newEmail.content
//             });
//             
//             fetchEmailLogs(page, limit, search, templateKey, failedOnly)
//             setSendModalOpen(false); // Modalı kapat
//         } catch (error) {
//             console.error("E-posta gönderilirken hata oluştu:", error);
//         }
//     };

    const renderPagination = () => {
        const totalPages = emailLogs.totalPages || 1;
        const paginationItems = [];
        const maxPagesToShow = 5;

        for (let i = 1; i <= totalPages; i++) {
            if (totalPages > maxPagesToShow) {
                if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
                    paginationItems.push(
                        <PaginationItem key={i} active={i === page}>
                            <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
                        </PaginationItem>
                    );
                } else if (i === 2 || i === totalPages - 1) {
                    paginationItems.push(
                        <PaginationItem key={i} disabled>
                            <PaginationLink>...</PaginationLink>
                        </PaginationItem>
                    );
                }
            } else {
                paginationItems.push(
                    <PaginationItem key={i} active={i === page}>
                        <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
                    </PaginationItem>
                );
            }
        }
        return paginationItems;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        const timeOptions = { hour: '2-digit', minute: '2-digit' };
        return `${date.toLocaleDateString(currentLocaleTag(), options)} - ${date.toLocaleTimeString(currentLocaleTag(), timeOptions)}`;
    };

// WAS (until #584): user search of the old modal (the new form searches through the service).
//     const handleUserSearch = async (inputValue = "") => {
//         if (inputValue.trim() === "") return; // Boş arama yapmayı önle
//         const users = await searchUsers(inputValue);
//         const options = users.map(user => ({
//             label: `${user.user_name} ${user.user_surname} (${user.user_email})`,
//             value: user.user_id
//         }));
//         setUserOptions(options);
//     };

// WAS (until #584): saved the template written in the old modal.
//     const handleSaveTemplate = async () => {
//         try {
//             const templateTitle = newEmail.konu; // Modal'daki konu inputundan al
//             const templateContent = newEmail.content; // Modal'daki içerik editoründen al
//             const templateId = selectedTemplate; // Eğer bir şablon seçiliyse onun ID'sini al
//     
//             if (!templateTitle || !templateContent) {
//                 toast.warn(t("emailsLogs.kaydetmekIcinGecerliBirBaslik"), { position: "top-right", autoClose: 5000 });
//                 return;
//             }
//     
//             const response = await saveOrUpdateTemplate(templateId, templateTitle, templateContent);
//             if (response.templateId || response.message) {
//                 toast.success(templateId ? t("emailsLogs.temaBasariylaGuncellendi") : t("emailsLogs.yeniTemaBasariylaKaydedildi"), { position: "top-right", autoClose: 5000 });
//                 setSelectedTemplate(response.templateId); // Eğer yeni oluşturulmuşsa ID'yi güncelle
//             } else {
//                 throw new Error(t("emailsLogs.yanitVerisiEksik"));
//             }
//         } catch (error) {
//             console.error('Tema kaydedilirken bir hata oluştu:', error);
//             toast.error(t("emailsLogs.temaKaydedilirkenHataOlustu"), { position: "top-right", autoClose: 5000 });
//         }
//     };

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title={t("emailsLogs.kayitlar")} pageTitle={t("emailsLogs.emails")} />
                <Card className="p-3">
                    <Row>
                        <Col md="1">
                            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                <DropdownToggle color="primary" caret>
                                    {t("emailsLogs.gosterim", { limit })}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => setLimit(10)}>10</DropdownItem>
                                    <DropdownItem onClick={() => setLimit(25)}>25</DropdownItem>
                                    <DropdownItem onClick={() => setLimit(50)}>50</DropdownItem>
                                    <DropdownItem onClick={() => setLimit(100)}>100</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                        <Col md="3">
                            <Input
                                type="text"
                                placeholder={t("emailsLogs.arama")}
                                value={search}
                                onChange={(e) => { setSearch(e.target.value); setPage(1); }}
                            />
                        </Col>
                        {/* #573 */}
                        <Col md="3">
                            <Input type="select" value={templateKey} aria-label={t("emailsLogs.sablonSuzgeci")} onChange={(e) => { setTemplateKey(e.target.value); setPage(1); }}>
                                <option value="">{t("emailsLogs.tumPostalar")}</option>
                                {sablonAnahtarlari.map((k) => <option key={k} value={k}>{k}</option>)}
                                <option value="TEST">TEST</option>
                                <option value="-">{t("emailsLogs.sablonsuzPostalar")}</option>
                            </Input>
                        </Col>
                        <Col md="2" className="d-flex align-items-center">
                            <div className="form-check mb-0">
                                <Input id="log-failed-only" className="form-check-input" type="checkbox" checked={failedOnly} onChange={(e) => { setFailedOnly(e.target.checked); setPage(1); }} />
                                <label className="form-check-label" htmlFor="log-failed-only">{t("emailsLogs.sadeceGitmeyenler")}</label>
                            </div>
                        </Col>
                        <Col md="3" className="text-end">
                            {/* WAS (backlog #160 öncesi): <Button color="primary" onClick={toggleSendModal}>Mail Gönder</Button>
                                Java backend'de SMTP gönderimi henüz yok; ölü Node ucuna gidiyordu. */}
                            {/* WAS (until #584): <Button color="primary" disabled title={t("emailsLogs.ePostaGonderimiHenuzJava")}>{t("emailsLogs.mailGonder")}</Button> */}
                            <Button color="primary" onClick={() => setGonderAcik(true)}>
                                {t("emailsLogs.mailGonder")}
                            </Button>
                        </Col>
                    </Row>
                </Card>
                <Card className="pt-3 pe-3 ps-3">
                    {loading ? (
                        <div>{t("common:yukleniyor")}</div>
                    ) : (
                        <Table responsive bordered striped>
                            <thead>
                                <tr style={{ height: '40px' }}>
                                    <th>{t("emailsLogs.baslik")}</th>
                                    <th>{t("emailsLogs.konu")}</th>
                                    <th>{t("emailsLogs.gonderen")}</th>
                                    <th>{t("emailsLogs.alici")}</th>
                                    <th>{t("emailsLogs.gonderimTarihi")}</th>
                                    <th>{t("emailsLogs.durum")}</th>
                                    <th>{t("emailsLogs.islem")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {emailLogs.data?.map(log => (
                                    <tr style={{ height: '65px' }} key={log.mail_log_id}>
                                        <td>
                                            {log.mail_log_title}
                                            {log.mail_log_template_key && <><br /><Badge color="light" className="text-body font-monospace">{log.mail_log_template_key}</Badge></>}
                                        </td>
                                        <td>{log.mail_log_subject}</td>
                                        <td>
                                            {log.mail_log_from_email}
                                            <br />
                                            <a href="#" className="text-primary">
                                                {log.sender_name} {log.sender_surname}
                                            </a>
                                        </td>
                                        <td>
                                            {log.mail_log_to_email}
                                            <br />
                                            <a href="#" className="text-primary">
                                                {log.receiver_name} {log.receiver_surname}
                                            </a>
                                        </td>
                                        <td>{formatDate(log.mail_log_insertdate)}</td>
                                        <td>
                                            <Badge color={log.is_sent ? "secondary" : "warning"}>
                                                {log.is_sent ? t("emailsLogs.gonderildi") : t("emailsLogs.basarisiz")}
                                            </Badge>
                                            {/* #573: gitmeyen postanın nedeni (güvenli mod, sunucu reddi, şifre çözülemedi ...) */}
                                            {!log.is_sent && log.mail_log_error && <div className="small text-muted mt-1">{log.mail_log_error}</div>}
                                        </td>
                                        <td>
                                            <Button color="warning" onClick={() => handleDetail(log.mail_log_id)}>{t("common:detay")}</Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Card>
                <Pagination className="pagination justify-content-center mt-3">
                    {renderPagination()}
                </Pagination>

                <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} size="lg">
                    <ModalHeader toggle={() => setModalOpen(false)}>{t("emailsLogs.mailDetayi")}</ModalHeader>
                    <ModalBody>
                        {/* WAS (backlog #160 öncesi): <div dangerouslySetInnerHTML={{ __html: selectedLog.mail_log_message }} />
                            Kayıtlı HTML sayfanın içine, oturumla aynı originde basılıyordu (script çalıştırabilirdi).
                            Artık betik çalıştıramayan, ayrı originli bir iframe'de. */}
                        {selectedLog && (
                            <div className="mb-3 small">
                                {selectedLog.mail_log_template_key && <div><span className="text-muted">{t("emailsLogs.sablonAnahtari")}: </span><code>{selectedLog.mail_log_template_key}</code></div>}
                                {!selectedLog.is_sent && selectedLog.mail_log_error && <Alert color="warning" className="py-2 mt-2 mb-0">{selectedLog.mail_log_error}</Alert>}
                                {selectedLog.mail_log_template_key && <div className="text-muted mt-2">{t("emailsLogs.baglantiGizli")}</div>}
                            </div>
                        )}
                        {selectedLog ? (
                            <iframe
                                title={t("emailsLogs.mailIcerigi")}
                                sandbox=""
                                srcDoc={selectedLog.mail_log_message || ""}
                                style={{ width: "100%", minHeight: 420, border: "1px solid var(--vz-border-color, #dee2e6)", borderRadius: 4, background: "#fff" }}
                            />
                        ) : (
                            <p>{t("common:yukleniyor")}</p>
                        )}
                    </ModalBody>
                </Modal>

                {
                // WAS (until #584): the old "Mail Gönder" modal (a CKEditor mail written in the modal; it needed the Node send endpoint that is gone). The new form is SablonGonder.jsx.
//                 <Modal isOpen={sendModalOpen} toggle={toggleSendModal} size="lg">
//                     <ModalHeader toggle={toggleSendModal}>{t("emailsLogs.mailGonder")}</ModalHeader>
//                     <ModalBody>
//                         <Row className="mb-3">
//                             <Col md="12">
//                                 <label>{t("emailsLogs.emailTemalari")}</label>
//                                 <Input
//                                     type="select"
//                                     value={newEmail.email_template_title}
//                                     onChange={handleTemplateChange}
//                                 >
//                                     <option value="">{t("emailsLogs.sablonSecin")}</option>
//                                     {emailTemplates.map((template) => (
//                                         <option key={`template-${template.email_template_id}`} value={template.email_template_id}>
//                                             {template.email_template_title || t("emailsLogs.baslikYok")}
//                                         </option>
//                                     ))}
//                                 </Input>
//                             </Col>
//                         </Row>
//                         <Row className="mb-3">
//                             <Col md="12">
//                                 <label>{t("emailsLogs.alicilarSistemKullanicilari")}</label>
//                                 <Select
//                                     isMulti
//                                     options={userOptions}
//                                     onInputChange={(inputValue) => {
//                                         console.log("Input Change Değeri:", inputValue); // Bu satırı ekleyerek değer güncelleniyor mu kontrol edin
//                                         handleUserSearch(inputValue);
//                                     }}
//                                     onChange={(selected) => setSelectedUsers(selected)}
//                                     placeholder={t("emailsLogs.kullaniciArayin")}
//                                     className="data-choices form-control"
//                                     isClearable
//                                     styles={{
//                                         color: 'white',
//                                         multiValueLabel: (base) => ({
//                                             ...base,
//                                             color: 'white', // Seçili etiketlerin metnini beyaz yap
//                                         })
//                                     }}
//                                 />
//                             </Col>
//                         </Row>
//                         <Row className="mb-3">
//                             <Col md="12">
//                                 <label>{t("emailsLogs.alicilarSistemdeKaydiOlmayanlar")}</label>
//                                 <CreatableSelect
//                                     isMulti
//                                     value={newEmail.ccRecipients.map((email) => ({ label: email, value: email }))}
//                                     onChange={(selectedOptions) => {
//                                         const emails = selectedOptions ? selectedOptions.map((option) => option.value) : [];
//                                         setNewEmail({ ...newEmail, ccRecipients: emails });
//                                     }}
//                                     placeholder={t("emailsLogs.ePostaEkleyinVeEnter")}
//                                     formatCreateLabel={(inputValue) => `"${inputValue}" eklensin`}
//                                     noOptionsMessage={() => t("emailsLogs.yazipEnterIleEkleyin")}
//                                     className="data-choices form-control"
//                                     styles={{
//                                         color: 'white',
//                                         multiValueLabel: (base) => ({
//                                             ...base,
//                                             color: 'white', // Seçili etiketlerin metnini beyaz yap
//                                         })
//                                     }}
//                                 />
//                             </Col>
//                         </Row>
//                         <Row className="mb-3">
//                             <Col md="12">
//                                 <label>{t("emailsLogs.kimden")}</label>
//                                 <Input
//                                     type="select"
//                                     value={newEmail.sender}
//                                     onChange={(e) => setNewEmail({ ...newEmail, sender: e.target.value })}
//                                 >
//                                     <option value="">{t("emailsLogs.kimdenSecin")}</option>
//                                     {systemEmails.map((email) => (
//                                         <option key={email.system_email_id} value={email.system_email_value}>
//                                             {email.system_email_title} [{email.system_email_value}]
//                                         </option>
//                                     ))}
//                                 </Input>
//
//                             </Col>
//                         </Row>
//                         <Row className="mb-3">
//                             <Col md="12">
//                                 <label>{t("emailsLogs.konu")}</label>
//                                 <Input
//                                     type="text"
//                                     placeholder={t("emailsLogs.konu")}
//                                     value={newEmail.konu} // "konu" olarak bağlandı
//                                     key={newEmail.konu} // Her güncellemede render olması sağlanıyor
//                                     onChange={(e) => setNewEmail({ ...newEmail, konu: e.target.value })}
//                                 />
//                             </Col>
//                         </Row>
//                         <Row className="mb-3">
//                             <Col md="12">
//                                 <label>{t("emailsLogs.mailIcerigi2")}</label>
//                                 <CKEditor
//                                     editor={ClassicEditor}
//                                     config={editorConfig}
//                                     data={newEmail.content}
//                                     onChange={(event, editor) => setNewEmail({ ...newEmail, content: editor.getData() })}
//                                 />
//                             </Col>
//                         </Row>
//                         <Row className="mb-3">
//                             <Col md="12" className="text-end">
//                                 <Button color="primary" size="sm" onClick={handleSaveTemplate}>{t("emailsLogs.temayiKaydet")}</Button>
//                             </Col>
//                         </Row>
//                     </ModalBody>
//                     <ModalFooter>
//                         <Button color="primary" onClick={handleSendEmail}>{t("common:gonder")}</Button>
//                         <Button color="primary" onClick={toggleSendModal}>{t("common:iptal")}</Button>
//                     </ModalFooter>
//                 </Modal>
                }
                <SablonGonder isOpen={gonderAcik} toggle={() => setGonderAcik(false)} onSent={gonderildi} />
                <ToastContainer/>
            </Container>
        </div>
    );
};

export default Logs;
